module.exports = __webpack_public_path__ + "img/img_006.d618ef1b.png";